import Query from 'library/util/query';

const RoiQuestions = async () =>
  await Query(` {
    roi_question_groups() {
      ui_order,
      roi_questions {
        id,
        text,
        answer_input_field_type,
        key_to_update,
        answer_data,
        current_user_answers {
          created_at,
          updated_at,
          body
        }
      }
    }
  }
  `);

export default RoiQuestions;
